export default {
  apiBase: 'https://api.deerlongstay.com',
  storageBase: 'https://storage.deerlongstay.com'
}
